import api from "../../utils/apiUserTienda";

export const getProductos = async () => {
  const res = await api.get("/api/tienda/productos/obtener");
  return res.data.data || [];
};

export const getProductoById = async (id) => {
  const res = await api.get(`/api/tienda/productos/obtener/${id}`);
  return res.data.data ?? null;
};

export const crearProducto = async (formData) => {
  const res = await api.post("/api/tienda/productos/crear", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const actualizarProducto = async (id, formData) => {
  const res = await api.put(`/api/tienda/productos/actualizar/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// Activa/inactiva varios productos a la vez reutilizando el update individual
// (solo se envía `estado`). Devuelve cuántos se actualizaron y cuántos fallaron.
export const cambiarEstadoProductosMasivo = async (ids, estado) => {
  const lista = Array.isArray(ids) ? ids : [];
  const estadoNum = Number(estado) === 1 ? 1 : 0;

  const results = await Promise.allSettled(
    lista.map((id) => {
      const fd = new FormData();
      fd.append("estado", String(estadoNum));
      return actualizarProducto(id, fd);
    })
  );

  const ok = results.filter((r) => r.status === "fulfilled").length;
  const fail = results.length - ok;
  return { ok, fail, total: results.length };
};

// Marca/desmarca como destacados varios productos a la vez reutilizando el
// update individual (solo se envía `destacado`). Devuelve cuántos se
// actualizaron y cuántos fallaron.
export const cambiarDestacadoProductosMasivo = async (ids, destacado) => {
  const lista = Array.isArray(ids) ? ids : [];
  const destacadoNum = Number(destacado) === 1 ? 1 : 0;

  const results = await Promise.allSettled(
    lista.map((id) => {
      const fd = new FormData();
      fd.append("destacado", String(destacadoNum));
      return actualizarProducto(id, fd);
    })
  );

  const ok = results.filter((r) => r.status === "fulfilled").length;
  const fail = results.length - ok;
  return { ok, fail, total: results.length };
};

export const crearProductoMasivo = async (file) => {
  const formData = new FormData();
  formData.append("archivo", file);
  const res = await api.post("/api/tienda/productos/crear-masivo", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};
